export enum Shops {
  CZ10MA = 'CZ10MA',
  SK10MA = 'SK10MA',
  PL20MA = 'PL20MA',
  HU20MA = 'HU20MA',
  HR10MA = 'HR10MA',
  SI10SI = 'SI10SI',
}
